<template>
	<div class="page-content__content">
		<div class="schedules">
			<SchedulesFilter/>
			<SchedulesTable :schedules-data="getSchedulesList"/>
			<div class="pagination" v-if="getSchedulesPagination.total > getSchedulesPagination.limit">
				<vue-awesome-paginate
					:total-items="getSchedulesPagination.total"
					:items-per-page="getSchedulesPagination.limit"
					:max-pages-shown="3"
					v-model="curPage"
				/>
			</div>
		</div>
	</div>
	<PageLoader v-if="isLoading"/>
</template>

<script>
import PageLoader from "@/components/base/utils/PageLoader.vue";
import { mapActions, mapGetters} from "vuex";
import SchedulesFilter from "@/components/sections/Schedules/SchedulesFilter.vue";
import SchedulesTable from "@/components/sections/Schedules/SchedulesTable.vue";

export default {
	name: "SchedulesPage",
	components: {PageLoader, SchedulesFilter, SchedulesTable},
	async created() {
		await this.requestSchedules();
	},
	computed: {
		curPage: {
			get() {
				return Math.round(this.getSchedulesPagination.offset / this.getSchedulesPagination.limit) + 1
			},
			set(value) {
				this.updatePagination({offset: (value - 1) * this.getSchedulesPagination.limit})
			}
		},
		...mapGetters({
			getSchedulesList: 'schedules/getSchedulesList',
			getSchedulesPagination: 'schedules/getSchedulesPagination',
			isLoading: 'isLoading',
		})
	},
	methods: {
		...mapActions({
			requestSchedules: 'schedules/requestSchedules',
			updatePagination: 'schedules/updatePagination',
		})
	}	
}
</script>

